export default __webpack_public_path__ + "static/media/Absolute Moonspill.9ab28fa6.jpg";